import DeleteIcon from '@mui/icons-material/Delete'
import { IconButton } from '@mui/material'
import { useState } from 'react'
import { checkCID, checkIpfs, ipfsToCID } from '../../helpers/Validators'
import InputField from '../../common/util/InputField'
import SelectElement from '../../common/util/SelectElement'
import { SelectItem } from '@nextui-org/react'

export const StaticAttributeRow = ({
    attribute,
    index,
    staticAttributes,
    setStaticAttributes,
}) => {
    const [editValue, setEditValue] = useState('')

    const attributeTypes = [
        { value: 'int32', label: 'Signed Integer (int32)' },
        { value: 'uint64', label: 'Unsigned Integer (uint64)' },
        { value: 'uint8', label: 'Small Unsigned Integer (uint8)' },
        { value: 'double', label: 'Float (double)' },
        { value: 'string', label: 'Text (string)' },
        { value: 'image', label: 'Image' },
    ]

    const changeAttributeName = ({ index, newName }) => {
        const tempStaticAttributes = [...staticAttributes]
        tempStaticAttributes[index].name = newName
            .toLowerCase()
            .replaceAll(' ', '_')
        setStaticAttributes(tempStaticAttributes)
    }

    const changeAttributeType = ({ index, newType }) => {
        const tempStaticAttributes = [...staticAttributes]
        tempStaticAttributes[index].type = newType
        setStaticAttributes(tempStaticAttributes)
    }

    const changeAttributeValue = ({ index, newValue }) => {
        const tempStaticAttributes = [...staticAttributes]
        tempStaticAttributes[index].value = newValue
        setStaticAttributes(tempStaticAttributes)
    }

    const deleteRow = ({ index }) => {
        const tempStaticAttributes = [...staticAttributes]
        tempStaticAttributes.splice(index, 1)
        setStaticAttributes(tempStaticAttributes)
    }

    return (
        <div className="flex flex-wrap justify-center my-1 bg-zinc-300 dark:!bg-paperl rounded-md">
            <div className="w-48 m-2">
                <InputField
                    variant="bordered"
                    label="Name"
                    value={attribute.name}
                    onChange={(e) =>
                        changeAttributeName({
                            index,
                            newName: e.target.value,
                        })
                    }
                    isRequired
                    isInvalid={attribute.name.length === 0}
                />
            </div>
            <div className="w-48 m-2">
                <SelectElement
                    label="Attribute Type"
                    variant="bordered"
                    classNames={{
                        label: 'text-black font-semibold dark:text-white',
                        errorMessage:
                            'text-red-500 dark:text-red-500 font-semibold text-left mt-1',
                        input: 'text-black font-semibold dark:text-white',
                    }}
                    placeholder="Select an option"
                    selectedKeys={
                        new Set([attribute.type !== null ? attribute.type : ''])
                    }
                    onChange={(e) => {
                        const newType = e.target.value
                        changeAttributeType({ index, newType })
                        if (newType === 'uint64') {
                            const newValue = attribute.value
                                ? parseInt(attribute.value)
                                : 0
                            setEditValue(newValue)
                            changeAttributeValue({
                                index,
                                newValue,
                            })
                        } else if (newType === 'double') {
                            const newValue = attribute.value
                                ? parseFloat(attribute.value)
                                : 0
                            setEditValue(newValue)
                            changeAttributeValue({
                                index,
                                newValue,
                            })
                        }
                    }}
                >
                    {attributeTypes.map((option) => (
                        <SelectItem key={option.value} value={option.value}>
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectElement>
            </div>
            <div className="w-88 m-2">
                <InputField
                    variant="bordered"
                    label="Value"
                    value={editValue}
                    onChange={(e) => {
                        setEditValue(e.target.value)
                        if (attribute.type === 'uint64') {
                            changeAttributeValue({
                                index,
                                newValue: parseInt(e.target.value),
                            })
                        } else if (attribute.type === 'double') {
                            changeAttributeValue({
                                index,
                                newValue: parseFloat(e.target.value),
                            })
                        } else if (
                            attribute.type === 'ipfs' ||
                            attribute.type === 'image'
                        ) {
                            let hash = e.target.value

                            if (checkCID(hash)) {
                                hash = ipfsToCID(hash)
                            }

                            changeAttributeValue({
                                index,
                                newValue: hash,
                            })
                        } else {
                            changeAttributeValue({
                                index,
                                newValue: e.target.value,
                            })
                        }
                    }}
                    isRequired
                    isInvalid={
                        attribute.value.length === 0 ||
                        ((attribute.type === 'uint64' ||
                            attribute.type === 'double') &&
                            isNaN(attribute.value)) ||
                        ((attribute.type === 'ipfs' ||
                            attribute.type === 'image') &&
                            !checkIpfs(attribute.value.toString()))
                    }
                />
            </div>
            <div className="my-auto">
                <IconButton
                    color="error"
                    size="large"
                    onClick={() => {
                        deleteRow({ index })
                    }}
                >
                    <DeleteIcon />
                </IconButton>
            </div>
        </div>
    )
}
